/**
 * Internal helper utilities for constructing and inspecting Redux-style
 * lifecycle action types (`::request`, `::success`, `::failure`).
 */
/**
 * Separates an action's base type from its lifecycle suffix.
 */
export const actionSuffixDivider = '::';
/**
 * Creates a matcher for action types ending with the requested suffix.
 *
 * @param suffix - The action suffix to match.
 * @returns A regular expression that matches the suffix at the end of an action type.
 */
export const matchActionSuffix = (suffix) => new RegExp(`${actionSuffixDivider}${suffix}$`);
/**
 * Extracts the base type from an action type string.
 *
 * @template T - The action type string.
 * @param type - The action type string to extract the base type from.
 * @returns The base type of the action type string, or `never` if the input string does not match the expected format.
 */
export function getBaseType(type) {
    return type.replace(matchActionSuffix('\\w+$'), '');
}
/**
 * Returns the action type of an action creator generated by `createAction`.
 *
 * @template T - The action type string.
 * @param actionCreator - The action creator whose action type to get.
 * @returns The action type used by the action creator.
 */
export function getType(actionCreator) {
    return `${actionCreator}`;
}
//# sourceMappingURL=utils.js.map